
import { Line } from "vue-chartjs";
import { X_POINT, Y_AXIS_WIDTH, emptyLabels, partografYAxis, partografXAxes, partografLayout } from "./partografAxis";

function fullArr(val: number): Array<number> {
  const arr: Array<number> = [];
  for (let i = 0; i <= X_POINT; i++) arr.push(val);
  return arr;
}

export default {
  extends: Line,
  props: {
    dataSet: [],
  },
  data() {
    return {
      labels: emptyLabels(),
      chartData: null,
      options: {
        scales: {
          yAxes: [
            partografYAxis({
              suggestedMin: 100,
              suggestedMax: 200,
              stepSize: 10,
            }),
          ],
          xAxes: partografXAxes(),
        },
        layout: partografLayout(),
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  methods: {
    buildChartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: "Normal Atas (160)",
            data: fullArr(160),
            pointRadius: 0,
            borderColor: "rgba(0, 150, 0, 0.8)",
            backgroundColor: "rgba(0, 200, 0, 0.10)",
            borderDash: [4, 4],
            borderWidth: 1,
            fill: "+1",
            spanGaps: true,
          },
          {
            label: "Normal Bawah (120)",
            data: fullArr(120),
            pointRadius: 0,
            borderColor: "rgba(0, 150, 0, 0.8)",
            backgroundColor: "transparent",
            borderDash: [4, 4],
            borderWidth: 1,
            fill: false,
            spanGaps: true,
          },
          {
            label: "DJJ",
            data: this.dataSet,
            pointStyle: "dot",
            pointRadius: 4,
            borderWidth: 2,
            spanGaps: true,
            tension: 0,
            fill: false,
            borderColor: "red",
            backgroundColor: "red",
          },
          {
            label: "Batas Atas (180)",
            data: fullArr(180),
            pointRadius: 0,
            borderColor: "rgba(200, 0, 0, 0.9)",
            borderDash: [6, 4],
            borderWidth: 2.5,
            fill: false,
            spanGaps: true,
          },
          {
            label: "Batas Bawah (100)",
            data: fullArr(100),
            pointRadius: 0,
            borderColor: "rgba(200, 0, 0, 0.9)",
            borderDash: [6, 4],
            borderWidth: 2.5,
            fill: false,
            spanGaps: true,
          },
        ],
      };
    },
    // Tebalkan angka bahaya 100 & 180 di sumbu-Y (merah, bold) — Chart.js v2 tak
    // mendukung font per-tick, jadi di-overdraw di afterDatasetsDraw.
    boldDangerTicksPlugin() {
      return {
        afterDatasetsDraw: function (chart) {
          const yAxis =
            chart.scales["y-axis-0"] ||
            chart.scales[Object.keys(chart.scales).find(function (k) {
              return k.indexOf("y-axis") === 0;
            })];
          if (!yAxis) return;
          const ctx = chart.ctx;
          ctx.save();
          ctx.font = "bold 12px Arial, sans-serif";
          ctx.fillStyle = "#c00";
          ctx.textAlign = "right";
          ctx.textBaseline = "middle";
          [100, 180].forEach(function (v) {
            const y = yAxis.getPixelForValue(v);
            // hapus label tipis asli lalu gambar ulang bold merah
            ctx.clearRect(yAxis.right - (Y_AXIS_WIDTH - 12), y - 9, Y_AXIS_WIDTH - 16, 18);
            ctx.fillText(String(v), yAxis.right - 8, y);
          });
          ctx.restore();
        },
      };
    },
    redraw() {
      this.chartData = this.buildChartData();
      this.renderChart(this.chartData, this.options);
    },
  },
  mounted() {
    this.addPlugin(this.boldDangerTicksPlugin());
    this.redraw();
  },
  watch: {
    dataSet: function () {
      this.redraw();
    },
  },
};
